export default __webpack_public_path__ + "static/peopleProcess-31b810837604af6475fac65c32aa8995.jpg";